/* eslint-disable security/detect-object-injection */
/* eslint-disable no-debugger */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

//import { ISwatchItem, SwatchComponent } from '@msdyn365-commerce/components';
import {
    /*DimensionTypes,*/ ArrayExtensions,
    getFallbackImageUrl,
    /*, ObjectExtensions*/
    getMediaLocationsById,
    MediaLocationsByIdInput,
    getAdditionalMediaLocationsForSelectedVariant,
    AdditionalMediaLocationsForSelectedVariantInput
} from '@msdyn365-commerce-modules/retail-actions';
import {
    /*getPayloadObject, getTelemetryAttributes, IPayLoad,*/ INodeProps,
    NodeTag,
    Node,
    ISingleSlideCarouselProps,
    IComponentNodeProps
} from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IImageData, IImageSettings, Image } from '@msdyn365-commerce/core';
import { /*ILobasDropdownItemProps,*/ ILobasDropdownProps /*, LobasSelectionType*/ } from './lobas-dropdown.props';
import classnames from 'classnames';
import { IDropdownState } from '../dropdown-state';
import LOBASSingleSlideCarousel from '../../../components/lobas-single-slide-carousel';
import { validateProductImages } from '../../../lobas-media-gallery/utils';
import { getCatalogId } from '@msdyn365-commerce/core-internal';

/**
 * IMediaGalleryThumbnailsViewProps Interface.
 */
export interface IMediaGalleryThumbnailsViewProps {
    ThumbnailsContainerProps: INodeProps;
    SingleSlideCarouselComponentProps: INodeProps;
    items?: IMediaGalleryThumbnailItemViewProps[];
}

/**
 * IMediaGalleryThumbnailItemViewProps Interface.
 */
export interface IMediaGalleryThumbnailItemViewProps {
    ThumbnailItemContainerProps: INodeProps;
    Picture: React.ReactElement;
}

/**
 * Props for carousel.
 */
interface IMediaGalleryCarouselItems<ItemType> {
    items: ItemType[];
    keys: (string | undefined)[];
}

/**
 *
 * DropDown component.
 * @extends {React.PureComponent<IDropdownProps, IDropdownState>}
 */
export class LobasDropdown extends React.PureComponent<ILobasDropdownProps, IDropdownState> {
    //private readonly selectMenu: React.RefObject<HTMLSelectElement> = React.createRef<HTMLSelectElement>();

    //private readonly payLoad: IPayLoad;

    private fallbackImage?: string;

    private readonly defaultThumbnailImageSettings: IImageSettings = {
        viewports: {
            xs: { q: 'w=100&m=8', w: 100, h: 0 },
            lg: { q: 'w=100&m=8', w: 100, h: 0 }
        },
        lazyload: false,
        disableLazyLoad: true,
        cropFocalRegion: true
    };

    public constructor(props: ILobasDropdownProps, state: IDropdownState) {
        super(props);

        const selectedItem = this.props.dropdownList.find(item => item.isDefault);
        if (selectedItem) {
            this.state = {
                selectedIndex: selectedItem.id,
                images: []
            };
            if (this.props.onChange) {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Update for default.
                this.props.onChange({
                    dropdownId: this.props.dropdownId,
                    selectId: selectedItem.id,
                    selectedValue: selectedItem.value
                });
            }
        } else {
            this.state = {
                selectedIndex: '',
                images: []
            };
        }
        //this.payLoad = getPayloadObject('click', props.telemetryContent!, this.props.dropdownName);
    }

    public async componentDidMount(): Promise<void> {
        const catalogId = getCatalogId(this.props.context.actionContext.requestContext);

        const productImages = async () => {
            return Promise.all(
                this.props.dropdownList.map(async dropdown => {
                    const actionInput = new MediaLocationsByIdInput(this.props.apiSettings!, dropdown.productId!, catalogId);
                    const images = await validateProductImages(
                        (await getMediaLocationsById(actionInput, this.props.context.actionContext))!,
                        this.props.context.actionContext
                    );

                    return {
                        productId: dropdown.productId!,
                        images: images
                    };
                })
            );
        };

        const input = new AdditionalMediaLocationsForSelectedVariantInput(
            this.props.dropdownList[0].productId!,
            +this.props.context.request.apiSettings.channelId,
            this.props.dropdownList[0].product.productVariant,
            catalogId
        );
        const test = await getAdditionalMediaLocationsForSelectedVariant(input, this.props.context.actionContext);

        if (test) {
            //
        }

        const images = await productImages();

        this.setState({ images });
    }

    public render(): JSX.Element {
        if (this.props.product) {
            this.fallbackImage = getFallbackImageUrl(this.props.product.ItemId, this.props.context.request.apiSettings);
        }

        return this._renderDropdown();
    }

    private _renderDropdown(): JSX.Element {
        //const { dropdownId, dropdownList, dropdownName, dropdownToggleName } = this.props;
        //const attribute = getTelemetryAttributes(this.props.telemetryContent!, this.payLoad);
        const mediaGalleryThumbnailCarouselItems = this._getMediaGalleryThumbnailItems();

        const Thumbnails: IMediaGalleryThumbnailsViewProps = {
            ThumbnailsContainerProps: { className: 'ms-media-gallery__thumbnails-container' },
            SingleSlideCarouselComponentProps: {
                tag: LOBASSingleSlideCarousel,
                className: 'ms-media-gallery__thumbnails',
                vertical: false,
                flipperPrevLabel: '', //resources.previousScreenshotFlipperText,
                flipperNextLabel: '', //resources.nextScreenshotFlipperText,
                parentId: this.props.dropdownId,
                useTabList: true,
                key: JSON.stringify(mediaGalleryThumbnailCarouselItems.keys)
            } as IComponentNodeProps<ISingleSlideCarouselProps>,
            items: mediaGalleryThumbnailCarouselItems.items
        };

        /*return (
            <select
                id={`msc-dropdown__entry-${dropdownId}`}
                ref={this.selectMenu}
                aria-label={dropdownName}
                className='msc-dropdown__select lobas-dropdown-select'
                onChange={this._onChanged}
                size={dropdownList.length + 1}
                {...attribute}
            >
                <option value='' aria-selected={this.state.selectedIndex === ''} selected={this.state.selectedIndex === ''} hidden disabled>
                    {dropdownToggleName}
                </option>
                {dropdownList.map(
                    (item: ILobasDropdownItemProps) =>
                        item && (
                            <option
                                value={item.id}
                                key={item.id}
                                selected={this.state.selectedIndex === item.id.toString()}
                                aria-selected={this.state.selectedIndex === item.id.toString()}
                                className={item.isDisabled ? 'msc-dropdown__select__disabled' : undefined}
                                style={{
                                    backgroundImage: `url("https://images-eu-prod.cms.commerce.dynamics.com/cms/api/gkvlchkxcr/imageFileData/ME2TQf?pubver=1")`
                                }}
                            >
                                {item.value}
                            </option>
                        )
                )}
            </select>
        );*/
        return this._renderThumbnails(Thumbnails);
    }

    /*private _renderSwatch(): JSX.Element {
        const swatchItems = this.props.dropdownList.map<ISwatchItem>(item => {
            return {
                ...item,
                itemId: item.id,
                dimensionType: this.props.dropdownName as DimensionTypes
            };
        });
        return <SwatchComponent list={swatchItems} apiSettings={this.props.apiSettings!} onSelectItem={this._selectSwatch} />;
    }*/

    /**
     * Updates state on swatch selection.
     * @param item - Selected swatch item.
     */
    /*private readonly _selectSwatch = async (item: ISwatchItem) => {
        this.setState({ selectedIndex: item.itemId });

        if (this.props.onChange) {
            await this.props.onChange({
                dropdownId: this.props.dropdownId,
                selectId: item.itemId,
                selectedValue: item.value
            });
        }
    };*/

    /*private readonly _onChanged = async (event: React.ChangeEvent<HTMLSelectElement>) => {
        this.setState({ selectedIndex: event.target.value });

        if (this.props.onChange) {
            await this.props.onChange({
                dropdownId: this.props.dropdownId,
                selectId: event.target.value,
                selectedValue: event.target.innerText
            });
        }
    };*/

    private readonly _onClicked = async (id: string, value: string) => {
        this.setState({ selectedIndex: id });

        if (this.props.onChange) {
            await this.props.onChange({
                dropdownId: this.props.dropdownId,
                selectId: id,
                selectedValue: value
            });
        }

        return (event: React.MouseEvent<HTMLLIElement>) => {
            event.preventDefault();
        };
    };

    private _renderThumbnails = (thumbnails: IMediaGalleryThumbnailsViewProps): JSX.Element => {
        const { ThumbnailsContainerProps, SingleSlideCarouselComponentProps, items } = thumbnails;

        return (
            <Node {...ThumbnailsContainerProps}>
                <Node {...SingleSlideCarouselComponentProps}>{items && items.map(this._renderThumbnailItem)}</Node>
            </Node>
        );
    };

    private _renderThumbnailItem = (thumbnail: IMediaGalleryThumbnailItemViewProps): JSX.Element => {
        const { ThumbnailItemContainerProps, Picture } = thumbnail;

        return <Node {...ThumbnailItemContainerProps}>{Picture}</Node>;
    };

    private readonly _getThumbnailItem = (
        image: IImageData,
        imageSettings: IImageSettings,
        index: string,
        id: string,
        value: string,
        tabIndex: number,
        modifiedActiveIndex?: string
    ): IMediaGalleryThumbnailItemViewProps => {
        const classes = classnames(
            'ms-media-gallery__thumbnail-item',
            modifiedActiveIndex === index ? 'ms-media-gallery__thumbnail-item-active' : ''
        );

        return {
            ThumbnailItemContainerProps: {
                tag: 'li' as NodeTag,
                className: classes,
                role: 'tab',
                tabIndex: tabIndex,
                key: index,
                'aria-label': image.altText,
                'aria-selected': modifiedActiveIndex === index,
                onClick: () => this._onClicked(id, value)
            },
            Picture: (
                <Image
                    requestContext={this.props.context.actionContext.requestContext}
                    className='ms-media-gallery__thumbnail'
                    {...image}
                    fallBackSrc={this.fallbackImage}
                    gridSettings={this.props.context.request.gridSettings!}
                    imageSettings={imageSettings}
                    loadFailureBehavior='hide'
                    imageFallbackOptimize={false}
                    bypassHideOnFailure={index === ''}
                />
            )
        };
    };

    private _getMediaGalleryThumbnailItems(): IMediaGalleryCarouselItems<IMediaGalleryThumbnailItemViewProps> {
        //const itemId = this.props.product?.ItemId ?? '';

        const mediaGalleryItems: IImageData[] = this.props.dropdownList.map(dropdown => {
            const productImage = this.state.images.filter(productImage => productImage.productId === dropdown.productId);
            const imageUrl =
                ArrayExtensions.hasElements(productImage) && ArrayExtensions.hasElements(productImage[0].images)
                    ? productImage[0].images[0].src
                    : '';
            return {
                src: imageUrl,
                altText: dropdown.id
            };
        });

        const thumbnailImageSettings: IImageSettings = {
            viewports: {
                xs: {
                    w: 100,
                    h: 0,
                    q: 'w=100&h=0&q=80&m=6&f=png',
                    qe: 't=w100qhigh'
                },
                sm: {
                    w: 100,
                    h: 0,
                    q: 'w=100&h=0&q=80&m=6&f=png',
                    qe: 't=w100qhigh'
                },
                lg: {
                    w: 100,
                    h: 0,
                    q: 'w=100&h=0&q=80&m=6&f=png',
                    qe: 't=w100qhigh'
                },
                xl: {
                    w: 100,
                    h: 0,
                    q: 'w=100&h=0&q=80&m=6&f=png',
                    qe: 't=w100qhigh'
                }
            },
            lazyload: false,
            disableLazyLoad: true,
            cropFocalRegion: true
        };

        if (thumbnailImageSettings) {
            thumbnailImageSettings.cropFocalRegion = true;
        }

        const hasMediaGalleryItems = ArrayExtensions.hasElements(mediaGalleryItems);

        if (!hasMediaGalleryItems) {
            return { items: [], keys: [] };
        }

        return {
            items: [
                ...mediaGalleryItems!.map((item: IImageData, index: number) =>
                    this._getThumbnailItem(
                        item,
                        thumbnailImageSettings ?? this.defaultThumbnailImageSettings,
                        this.props.dropdownList[index].id,
                        this.props.dropdownList[index].id,
                        this.props.dropdownList[index].value,
                        index,
                        this.props.dropdownList.find(item => item.isDefault)?.id
                    )
                )
            ],
            keys: [...mediaGalleryItems!.map(item => item.src)]
        };
    }

    /*private _getEmptyThumbnailItem(
        imageSettings: IImageSettings | undefined,
        index: number,
        modifiedActiveIndex: number
    ): IMediaGalleryThumbnailItemViewProps {
        const classes = classnames(
            'ms-media-gallery__thumbnail-item',
            modifiedActiveIndex === index ? 'ms-media-gallery__thumbnail-item-active' : ''
        );
        return {
            ThumbnailItemContainerProps: {
                tag: 'li' as NodeTag,
                className: classes,
                role: 'tab',
                tabIndex: 0,
                key: 'empty',
                'aria-label': '',
                'aria-selected': modifiedActiveIndex === index,
                onClick: this._onClicked('', '')
            },
            Picture: (
                <Image
                    requestContext={this.props.context.actionContext.requestContext}
                    className='ms-media-gallery__thumbnail-item__image'
                    src='empty'
                    gridSettings={this.props.context.request.gridSettings!}
                    imageSettings={imageSettings ?? this.defaultThumbnailImageSettings}
                    loadFailureBehavior='empty'
                />
            )
        };
    }*/
}
